import * as React from "react"

import {Helmet } from 'react-helmet';
import { withPrefix, Link } from "gatsby"

import '../../node_modules/foundation-sites/dist/css/foundation.css'
import '../css/customfonts.scss';
import '../css/montserrat_font.css';
import '../css/josefinsans_font.css';
import '../css/style.scss';
import '../css/scrolldown.scss';
import '../css/mousescroll.scss'
import '../css/musicplayer.scss';

import leonprofilevideo from "../img/leonprofilevideo.mp4";

// markup
const IndexPage = () => {
  return (
    <div> 

      <div className="intro-image-container">
          <div className="intro-image"></div>
      </div>

      <div id="loading_overlay" className="loading_overlay_out"></div>

      <div id="content">
        <div id="absolute_header">
            <a href="#free-audio-kit" className="goToFreeSectionBtn btn btn-three noselect show-for-small-only">Free Audio Kit</a>
            {/* <a href="#free-audio-kit" className="goToFreeSectionBtn btn btn-three noselect show-for-medium padding-20">Get Our Free Audio Kit</a> */}
        </div>

        <div id="intro-section"  className="grid-y">
            <div className="cell medium-1" ></div>
            <div className="cell small-10 medium-9">
                <div className="grid-x">

                    <div className="cell large-2"></div>
                    <div className="cell large-8 padding-top-100">

                        <div className="grid-x text-center">
                            <div className="cell ">
                                <h1 id="title" className="titlefont">Tonica</h1>
                                <p id="subtitle" className="titlefont">I love to <span id="category_label">Create Music</span></p>
                            </div>

                            <div className="cell margin-top-30">
                                <div id="random-track-container">
                                    <div className="grid-x grid-padding-x">

                                        <div className="cell small-1"></div>

                                        <div className="cell small-1">
                                            <div id="playbutton" className="playbutton">
                                                <img src="./img/play.png" alt="" />
                                            </div>
                                        </div>

                                        <div className="cell small-8">
                                            <div className="loader">
                                                <img src="./img/loader2.svg" />
                                                <p>Loading...</p>
                                            </div>
                                            <div id="waveform" className="invisible margin-bottom-10">


                                            </div>

                                        </div>

                                        <div className="cell small-1">
                                            <div id="new">
                                                <div className="treat-wrapper"></div>
                                                <a id="next-track" className="next" ></a>
                                            </div>
                                        </div>
                                        <div className="cell small-1"></div>
                                    </div>

                                    <div className="grid-x grid-padding-x">

                                        <div className="cell small-3 medium-4"></div>

                                        <div className="cell small-6 medium-4">
                                            <div className="volume_slider">
                                                <div className="volume_off_icon"></div>
                                                <input type="range" min="1" max="100" value="50" className="slider" id="myRange" />
                                                <div className="volume_on_icon"></div>
                                            </div>
                                        </div>

                                        <div className="cell small-3 medium-4"></div>
                                    </div>


                                </div>

                            </div>

                        </div>

                    </div>
                    <div className="cell large-2"></div>
                </div>
            </div>
            <div className="cell small-1"></div>
            <div className="cell small-1">
                <div className="grid-x">
                    <div className="cell large-2"></div>
                    <div className="cell large-8">
                        <div>
                            <div className="scroll-down-container">
                                <a href="#team-section" className="scroll-down" address="true"></a>
                            </div>
                        </div>

                    </div>
                    <div className="cell large-2"></div>
                </div>
            </div>
        </div>

        <div id="music-section" className="grid-x grid-padding-x">
            <div className="cell large-2"></div>
            <div className="cell large-8 padding-top-100 padding-bottom-50">

                <h2 id="one_minute_title" className="text-center margin-bottom-100 titlefont">One Minute Show</h2>
                <p id="pick_vibe" className="text-center titlefont">Pick a Vibe...</p>

                <div className="grid-x grid-padding-x">

                    <div className="cell small-1 hide-for-large"></div>

                    <div className="cell small-10 large-12">
                        <div id="playlist-categories" className="grid-x grid-padding-x margin-bottom-50"></div>

                        <div className="grid-x grid-padding-x">

                            <div className="cell small-2">
                                <div id="playlist-play-btn" className="playbutton text-center">
                                    <img src="./img/play.png" alt="" />
                                </div>
                            </div>

                            <div className="cell small-10 margin-bottom-30">
                                <div className="loader">
                                    <img src="./img/loader2.svg" />
                                    <p>Loading...</p>
                                </div>
                                <div id="playlistwave">
                                    
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="cell small-1 hide-for-large"></div>
                </div>

                <div className="grid-x grid-padding-x">

                    <div className="cell small-3 medium-4"></div>

                    <div className="cell small-6 medium-4">
                        <div className="volume_slider">
                            <div className="volume_off_icon"></div>
                            <input type="range" min="1" max="100" value="50" className="slider" id="myRange" />
                            <div className="volume_on_icon"></div>
                        </div>
                    </div>

                    <div className="cell small-3 medium-4"></div>
                </div>

                <div id="playlist-tracks" className="grid-x grid-padding-x margin-bottom-50">
                    <div className="cell auto">

                        <div className="grid-x">

                            <div className="cell small-1"></div>

                            <div className="cell small-11">
                                <p id="track-length"><span id="track-length-amount"></span> tracks</p>

                                <div className="grid-x">
                                    <div className="cell small-11">
                                        <ul id="track-list"></ul>
                                    </div>

                                    <div className="cell small-1">
                                        <a className="mouse-scroll" href="#">
                                        <span className="mouse">
                                            <span className="mouse-movement"></span>
                                        </span>
                                            <span className="mouse-message fadeIn">scroll</span>
                                        </a>
                                    </div>
                                </div>

                            </div>
                        </div>

                    </div>
                </div>

            </div>
            <div className="cell large-2"></div>
        </div>

        <div id="blogs-section" className="grid-x grid-padding-x">
            <div className="cell large-2"></div>
            <div className="cell large-8 padding-top-100 padding-bottom-100">

                <h2 className="text-center margin-bottom-50 titlefont">Blogs</h2>

                <div className="text-center">
                    <a id="wwh_maintheme_blog_link" className="link" href="https://store.steampowered.com/newshub/app/865360/view/1603772016011328943" target="_blank">Dev Diary - Composing the We Were Here Together Theme</a>
                    <p className="sidenote_text margin-top-40">More coming soon..</p>
                </div>

            </div>
            <div className="cell large-2"></div>
        </div>

        <div id="team-section" className="grid-y padding-bottom-100">
            <div className="grid-x grid-padding-x">
                <div className="cell large-2"></div>
                <div className="cell large-8 padding-top-100">
                    <div className="margin-top-30 margin-bottom-50">
                        <p className="titlefont text-center fancy-text margin-bottom-100">Who is behind Tonica?</p>
                    </div>

                </div>
                <div className="cell large-2"></div>
            </div>

            <div className="grid-x grid-padding-x padding-bottom-100">
                <div className="cell medium-1"></div>
                <div className="cell small-12 medium-10 padding-top-50">

                    <div className="card-grid grid-x grid-padding-x small-up-1 large-up-1">
                        <div className="cell margin-bottom-50">
                            <div className="card">
                                <div className="card-divider titlefont">
                                    <p>Leon van der Stel</p>
                                </div>
                                <video preload='auto' autoPlay loop muted playsinline >
                                    <source src={leonprofilevideo} type="video/mp4" />
                                    Your browser does not support HTML5 video.
                                </video>
                                <div className="card-section subtext">
                                    <p>A crafter of environments and beats with synths, keys and a laptop at the fingertips.</p>
                                    <p>In my spare time I'm creating artificial algorithms, so one day the world would
                                        be controlled by music making robots 😉</p>
                                </div>
                            </div>
                        </div>
                        {/* <div className="cell margin-bottom-50">
                            <div className="card">
                                <div className="card-divider titlefont">
                                    <p>Jos Platschorre</p>
                                </div>
                                <video autoplay loop muted playsinline >
                                    <source src="./img/josprofilevideo.mp4" type="video/mp4" />
                                </video>
                                <div className="card-section subtext">
                                    <p>A handy man who hits the right notes with his voice, instruments and compositions.</p>
                                    <p>From woodworking to philosophy I can think of fixing your chair, but could not tell you the meaning of life 🙃</p>
                                </div>
                            </div>
                        </div> */}
                        {/* <div className="cell margin-bottom-50">
                            <div className="card">
                                <div className="card-divider titlefont">
                                    <p>Tom Hartman</p>
                                </div>
                                <video autoplay loop muted playsinline >
                                    <source src="./img/tomprofilevideo.mp4" type="video/mp4" />
                                </video>
                                <div className="card-section subtext">
                                    <p>A complete nerd in playing instruments, songwriting and recording.</p>
                                    <p>If I'm not busy with one of these things, I'm opening the gate for boatsmen in the woods. Ferry important 😃</p>
                                </div>
                            </div>
                        </div> */}
                    </div>

                </div>
                <div className="cell medium-1"></div>
            </div>
            
            <div className="grid-x grid-padding-x">
                <div className="cell medium-1"></div>
                <div className="cell small-12 medium-10">

                    <p className="titlefont fancy-text2">Why?</p>
                    <p className="font-size-medium margin-bottom-20">I love making music that is shaped by musicians, different characters, instruments and stories</p>
                    <p className="titlefont fancy-text2">How?</p>
                    <p className="font-size-medium margin-bottom-20">Using synthesizers, instruments and drum racks combined with the strengths of a DAW (Ableton is my favorite) and all the musicians in my network</p>
                    <p className="titlefont fancy-text2">What?</p>
                    <p className="font-size-medium margin-bottom-20">Beautifully crafted music compositions, beats, recordings, play sessions and soundscapes</p>

                </div>
                <div className="cell medium-1"></div>
            </div>
        </div>

        {/* <div id="service-section" className="grid-y">
            <div className="grid-x grid-padding-x">
                <div className="cell large-2"></div>
                <div className="cell large-8 padding-top-100">
                    <div className="margin-top-30 margin-bottom-50 text-center">
                        <p className="titlefont text-center fancy-text">Our Services</p>
                        <p>We make music for your story, game, film, animation and other narratives</p>
                    </div>

                </div>
                <div className="cell large-2"></div>
            </div>

            <div className="grid-x grid-padding-x padding-bottom-100">
                <div className="cell medium-1"></div>
                <div className="cell small-12 medium-10 padding-top-50">

                    <div className="grid-x grid-padding-x small-up-1 medium-up-2 large-up-4">
                        <div className="cell margin-bottom-30">
                            <div className="card">
                                <div className="card-section text-center">
                                    <p className="titlefont">Music Composition</p>
                                    <p>Tailor-made music tracks and soundscapes</p>
                                </div>
                            </div>
                        </div>
                        <div className="cell margin-bottom-30">
                            <div className="card">
                                <div className="card-section text-center">
                                    <p className="titlefont">Riff</p>
                                    <p>Instrument play sessions</p>
                                </div>
                            </div>
                        </div>
                        <div className="cell margin-bottom-30">
                            <div className="card">
                                <div className="card-section text-center">
                                    <p className="titlefont">Songwriting</p>
                                    <p>Tailor-made songs with lyrics</p>
                                </div>
                            </div>
                        </div>
                        <div className="cell margin-bottom-30">
                            <div className="card">
                                <div className="card-section text-center">
                                    <p className="titlefont">Music Software</p>
                                    <p>Tailor-made software tools that makes your music workflow easier</p>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <div className="cell medium-1"></div>
            </div>
        </div> */}

        {/* <div id="price-section" className="grid-y">
            <div className="grid-x grid-padding-x">
                <div className="cell large-2"></div>
                <div className="cell large-8 padding-top-100">
                    <div className="margin-top-30 margin-bottom-50 text-center">
                        <p className="titlefont text-center fancy-text inline_block">Price Tag <div className="pricetag_icon inline_block margin-left-10"></div></p>
                    </div>

                </div>
                <div className="cell large-2"></div>
            </div>

            <div className="grid-x grid-padding-x padding-bottom-50 padding-20">
                <div className="cell medium-1"></div>
                <div className="cell small-12 medium-10">

                    <div className="grid-x grid-padding-x">
                        <div className="cell medium-1"></div>
                        <div className="cell medium-10 text-center">

                            <p>We want to be open and transparent.</p>

                            <p>Of course all things we do depend highly on your wishes.</p>

                        </div>
                        <div className="cell medium-1"></div>
                    </div>

                </div>
                <div className="cell medium-1"></div>
            </div>

            <div className="grid-x grid-padding-x padding-bottom-100">
                <div className="cell medium-1"></div>
                <div className="cell small-12 medium-10">

                    <div className="card-grid grid-x grid-padding-x small-up-1 large-up-3">
                        <div className="cell margin-bottom-50">
                            <div className="card">
                                <div className="card-divider titlefont fancy-text2">
                                    <p>Fixed price per track</p>
                                </div>
                                <div className="card-section subtext">
                                    <div className="titlefont pricing">
                                        <p className="inline_block margin-bottom-0">500  ≤</p>
                                        <div className="pricetag_icon inline_block margin-10 margin-bottom-0"></div>
                                        <p className="inline_block margin-bottom-0">≤  2000 euro</p>
                                    </div>
                                    <div className="margin-top-20">
                                        <p>A fixed price for a complete track or many tracks. </p>
                                        <p>
                                            Our data tells us that great tracks can be
                                        made between 40 and 80 hours. It is self explanatory that a track of 1 minute with few
                                        musical changes is cheaper then carefully forged game ost tracks. It includes everything from the creation to final renders.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="cell margin-bottom-50">
                            <div className="card">
                                <div className="card-divider titlefont fancy-text2">
                                    <p>Hour Rate (Music)</p>
                                </div>
                                <div className="card-section subtext">
                                    <div className="titlefont pricing">
                                        <p className="inline_block margin-bottom-0">35 ≤</p>
                                        <div className="pricetag_icon inline_block margin-10 margin-bottom-0"></div>
                                        <p className="inline_block margin-bottom-0">≤ 65 euro per hour</p>
                                    </div>
                                    <div className="margin-top-20">
                                        <p>Not all things are complete tracks.</p>
                                        <p>For example, recently we have recorded 6 guitar lines for 6 hiphop tracks within 6 hours. Think of
                                        recordings, small loops and our consultancy / supervision.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="cell margin-bottom-50">
                            <div className="card">
                                <div className="card-divider titlefont fancy-text2">
                                    <p>Hour Rate (Software)</p>
                                </div>
                                <div className="card-section subtext">
                                    <div className="titlefont pricing">
                                        <p className="inline_block margin-bottom-0">35 ≤</p>
                                        <div className="pricetag_icon inline_block margin-10 margin-bottom-0"></div>
                                        <p className="inline_block margin-bottom-0">≤ 65 euro per hour</p>
                                    </div>
                                    <div className="margin-top-20">
                                        <p>Other things we love to do is writing software.</p>
                                        <p>
                                            To name a few, customized audio convert tools that match your precise audio / video render flow,
                                            a custom app for uploading your content to different online channels, making your website like this one, an efficient selection program for selecting quickly your best hits of long recordings
                                            and unity music tools for adaptive music.
                                        </p>

                                        <p>
                                            For software contact <a id="leon_software_linkedin" href="https://www.linkedin.com/in/leonvanderstel/" target="_blank">Leon van der Stel</a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="cell padding-20">
                        <ul>
                            <li>
                                <p>No extra costs, travel allowance is included</p>
                            </li>
                            <li>
                                <p>Only if we agree upon a fixed price, at the start of a job we ask for some amount of the price paid upfront and the rest when the job finishes.</p>
                            </li>
                        </ul>

                        <p className="margin-top-40 margin-bottom-50">Making music is not just making a product. It is taking the time and putting in the effort to create something truly remarkable 😃</p>

                        <p><i>Ready? <a id="price_goto_contact" href="#contact-section">Contact us</a></i></p>
                        <p><i>Not ready yet? Get started with our <a id="price_goto_freekit" href="#free-audio-kit">freely available audio kit</a></i></p>
                    </div>

                </div>
                <div className="cell medium-1"></div>
            </div>
        </div> */}

        {/* <div id="free-audio-kit" className="grid-y">
            <div id="free_background_overlay"></div>
            <div id="free_section_content" className="grid-x grid-padding-x">
                <div className="cell large-2"></div>
                <div className="cell large-8 padding-top-50 padding-bottom-100">

                    <p className="titlefont fancy-text text-center padding-bottom-50">Free Audio Kit</p>

                    <div className="text-center">
                        <img id="audio_kit_img" src="./img/tonica_free_audio_kit.png" alt="" />
                    </div>

                    <div id="before-download" className="margin-top-50 grid-x sidenote_text">
                        <div className="cell">
                            <p>
                                <span>The download will be sent to your email. We won't use your email for spam.
                                By downloading you agree that we will save your email.</span><br />

                                <span className="show-for-medium">If you like this one we are planning to make a second one that is freely available as well. We will
                                use your email to notify you when it's out.</span>
                            </p>

                        </div>


                        <div id="download_errors" className="errors cell hide">
                            <p>Please enter a valid email, the download will be sent to this email</p>
                        </div>

                        <div className="cell medium-8 margin-bottom-20">
                            <input id="free_download_input" type="text" placeholder="email..." />
                        </div>

                        <div className="cell medium-4 text-center">
                            <button id="download_btn">DOWNLOAD</button>
                        </div>
                    </div>

                    <div id="pending-download" className="cell margin-top-50 margin-bottom-50 hide">
                        <div className="loader">
                            <img src="./img/loader2.svg" />
                            <p>Sending email...</p>
                        </div>
                    </div>

                    <div id="after-download" className="cell margin-top-100 margin-bottom-50 text-center hide">
                        <p className="titlefont fancy-text">Happy Creating!</p>
                        <p>Please check your inbox, if it is not in there check your spam folder.</p>
                        <p>Do you want more highly customized music or software that suits your needs? These are our <a href="#price-section">ratings.</a></p>
                        <p>Please retry or <a href="#contact-section">contact us</a> if you didn't receive the mail.</p>
                    </div>

                    <div id="after-error" className="errors cell margin-top-100 margin-bottom-100 text-center hide">
                        <p>Oops, something went wrong could not send mail please <a href="#contact-section">contact us</a></p>
                    </div>

                    <div id="intro_message_download" className="text-center margin-top-50 margin-bottom-100">
                        <p>We have put a lot of effort into creating and recording audio for this free audio kit.</p>
                        <p>You can freely use it anywhere and anyway you want!</p>
                        <p>The only thing we ask in return is that: </p>

                        <div className="smalltext margin-bottom-30">
                            <p className="margin-0">Mention Tonica wherever you use it </p>
                            <p className="margin-0">Share it with your creative friends, word of mouth</p>
                            <p className="margin-0">Share this kit on your social media like linkedin, facebook, etc</p>
                        </div>

                        <p>Enjoy 😃</p>
                    </div>

                    <div className="text-center margin-top-20 margin-bottom-20">
                        <div className="fb-share-button" data-href="https://tonica-music.com/#free-audio-kit" data-layout="button" data-size="small"><a target="_blank" href="https://www.facebook.com/sharer/sharer.php?u=http%3A%2F%2Ftonica-music.com%2F%23free-audio-kit&amp;src=sdkpreparse" className="fb-xfbml-parse-ignore">Share</a></div>
                        <a href="https://twitter.com/share?ref_src=twsrc%5Etfw" className="twitter-share-button" data-show-count="false">Tweet</a>
                        <script type="IN/Share" data-url="https://tonica-music.com/#free-audio-kit"></script>
                    </div>

                    <p className="titlefont fancy-text">For whom?</p>

                    <ul>
                        <li>Anyone looking for royalty free music and samples</li>
                        <li>Game developers, for use in their game / prototype</li>
                        <li>Concept artists, for quick ideas</li>
                        <li>Musicians looking for tools and inspiration</li>
                        <li>Video editors, making their new blockbuster</li>
                    </ul>

                    <p className="titlefont fancy-text">What's inside?</p>
                    <ul>
                        <li>577 MB</li>
                        <li>3 royalty free tracks</li>
                        <li>84 samples (beats, percussion, strings, synths, atmosphere and much more)</li>
                        <li>4 adaptive tensions levels</li>
                        <li>wav</li>
                        <li>48 kHz & 24bit</li>
                    </ul>

                    <p className="margin-top-50"><i>Are you ready to go a step further? Check our <a id="freekit_goto_price" href="#price-section">ratings</a> and contact us</i></p>
                </div>
                <div className="cell large-2"></div>
            </div>
        </div> */}

        <div id="contact-section" className="grid-x grid-padding-x padding-bottom-100">

            <div className="intro-image-container">
                <div className="intro-image"></div>
            </div>

            <div className="cell large-2"></div>
            <div className="cell large-8 padding-top-100">

                <div className="grid-y text-center">
                    <div className="cell margin-bottom-50">
                        <p className="titlefont fancy-text">On the same wavelength?</p>
                        <p>I'd love to hear from you!</p>
                    </div>
                    <div className="cell">
                        <div className="grid-x">

                            <div className="cell">
                                <p>leonstel5@gmail.com</p>
                                <p className="inline_block">or say hello on Whatsapp</p>
                                <div className="whatsapp_icon inline_block margin-left-10 margin-right-10"></div>
                                <p className="inline_block">+31(0)6 2557 3657</p>
                            </div>

                        </div>
                    </div>
                </div>

            </div>
            <div className="cell large-2"></div>
        </div>
      </div>  

      <Helmet>
          <script src={withPrefix('dist/bundle.js')} type="text/javascript" />
      </Helmet>      
    </div>
  )
}

export default IndexPage
